import React, { useState } from 'react'
import DefaultObservationList from '../DefaultObservationList';
import { FormControl, InputLabel, IconButton, TextField, MenuItem, Select, Grid, InputAdornment, Dialog } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Photos from '../Photos';
import { getErrorProps } from '../../utils';
import { makeStyles } from "@material-ui/core"
import MapsIcon from '@material-ui/icons/Map'
import SectionsMap from './SectionsMap';
import { geometry2feature, location2geoJson } from '../../utils/location'
import { useStore } from '../../Store'
import { findPlot } from '../../utils/';

// filteren op status
// berekenen afstand
// tonen punten / vierkant maken 25 x 25m
import BottomNavigationCustom from '../BottomNavigationCustom';
import Header from '../Header';

const Sections = ({ formik, readonly, observations, onSelect, onDelete }) => {
  const { plots } = useStore()
  const plot= findPlot(plots, formik.values.plot)

  const setSection = (value) => {
    formik.setFieldValue('section', value)
    formik.setFieldValue('observations', formik.values.sections[value].observations)
  }
  
  const section_remarks = `sections[${formik.values.section}].extraInfo['opmerking_obs']`
  const section_status = `sections[${formik.values.section}].statusId`
  const section_gebruik_fuiken = `sections[${formik.values.section}].extraInfo['gebruik_fuiken']`
  const section_uploads = `sections[${formik.values.section}].uploads`


  return (
    formik.values.section > -1 ?
      <Grid container>
        <Grid item xs={12} >
          <SectionFilter
            plot= {plot}
            sections={formik.values.sections}
            section={formik.values.section}
            setSection={(value) => setSection(value)}
          />
        </Grid>
        <Grid item xs={12} >
          <Alert severity="info">Info</Alert>
        </Grid>
        <Grid item xs={12}>
          <TextField select disabled={readonly} label="water bezocht?" variant="standard" name={section_status} fullWidth {...getErrorProps(formik, section_status)} {...formik.getFieldProps(section_status)} >
            <MenuItem key={3} value={3}>ja</MenuItem>
            <MenuItem key={4} value={4}>nee</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField select disabled={readonly} label="gebruik fuiken?" variant="standard" name={section_gebruik_fuiken} fullWidth {...getErrorProps(formik, section_gebruik_fuiken)} {...formik.getFieldProps(section_gebruik_fuiken)} >
            <MenuItem key={'nee'} value={'nee'}>nee</MenuItem>
            <MenuItem key={'ja'} value={'ja'}>ja</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} >
          <TextField disabled={readonly} label="opmerkingen water" multiline variant="standard" name={section_remarks} fullWidth  {...getErrorProps(formik, section_remarks)} {...formik.getFieldProps(section_remarks)} />
        </Grid>
        <Grid item xs={12}>
          <Photos
            uploads={formik.values.sections[formik.values.section].uploads}
            setUploads={(uploads) => formik.setFieldValue(section_uploads, uploads)}
            readonly={readonly}
            formik={formik}
            marginBottom='0px'
          />
        </Grid>
        <Grid item xs={12} >
          <Alert severity="info">Waarnemingen</Alert>
        </Grid>
        <Grid item xs={12} >
          <DefaultObservationList readonly={readonly} observations={observations} onSelect={onSelect} onDelete={onDelete} />
        </Grid>
      </Grid>
      : null
  )
}

const SectionFilter = ({ plot, section, setSection, sections }) => {
  const [open, setOpen] = useState(false)
  const useStyles = makeStyles({
    select: {
      "& .MuiSvgIcon-root": {
        position: 'relative',
        marginLeft: '-10px',
      },
    },
  });
  const classes = useStyles()
  const position = geometry2feature(plot.location.geometry).geometry.coordinates.reverse()
  const features= sections
  .map((s,i) => {
    const location= plot.children.find(c => c.description === s.description)?.location
    return { ...s, location, index: i }
  })
  .filter(s => s.location)
  .map(s => {
    const geo= location2geoJson(s.location)
    return {
      type: 'Feature',
      properties: {...s},
      geometry: geo
    }
  })
  const zoom = 15
  const polygon= location2geoJson(plot.location)
  const onSelect = (value) => {
    setOpen(false)
    setSection(value)
  }

  const sectionName= (section) => {
    const water= plot.children.find(w => w.description === section.description)?.extraInfo.telgebiednaam
    return water ? `${section.description} (${water})` : section.description
  }

  return (
    <>
      <FormControl fullWidth={true}>
        <InputLabel id="label_water">Water</InputLabel>
        <Select
          className={classes.select}
          labelId="label_water"
          id="label_water"
          value={section}
          onChange={(e) => setSection(e.target.value)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton aria-label="toon wateren" onClick={(e) => setOpen(true)} >
                <MapsIcon />
              </IconButton>
            </InputAdornment>
          }
        >
          {sections.map((item, i) => (
            <MenuItem value={i} key={i}>{sectionName(item)}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <Dialog open={open} fullScreen={true}>
        <Header backAction={() => setOpen(false)} title="Kies een water" />
        <SectionsMap
          onSelect={(value) => onSelect(value)}
          section={section}
          plot={polygon}
          features={features}
          zoom={zoom}
          position={position}
        />
        <BottomNavigationCustom />
      </Dialog>
    </>

  )

}
export default Sections